/**
 * DataAgent Settings Vue Application
 *
 * @package DataAgent
 * @since 1.1.0
 */

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';

// Create pinia (store)
const pinia = createPinia();

// Create and mount the Vue application
const app = createApp(App);

// Use pinia
app.use(pinia);

// Mount the app
app.mount('#dataagent-settings-dom');